var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8141 15.7162C38.9904 10.7107 48.6867 8.79285 58.1529 10.3091C67.6191 11.8253 76.2314 16.6754 82.4352 23.9842C88.6391 31.293 92.026 40.5787 91.9843 50.1655C91.9426 59.7522 88.4752 69.0082 82.208 76.2628C75.9408 83.5173 67.2866 88.2925 57.8077 89.7263C48.3288 91.1601 38.6494 89.1581 30.517 84.0817C22.3845 79.0052 16.3347 71.1889 13.4596 62.0433C13.0041 60.5945 13.8094 59.0507 15.2583 58.5952C16.7071 58.1397 18.2509 58.945 18.7064 60.3939C21.1881 68.2877 26.4099 75.0344 33.4294 79.4161C40.4488 83.7977 48.8034 85.5257 56.9851 84.2881C65.1668 83.0505 72.6366 78.9289 78.046 72.6672C83.4555 66.4056 86.4484 58.4162 86.4843 50.1415C86.5204 41.8669 83.597 33.852 78.2421 27.5434C72.8874 21.235 65.4537 17.0485 57.2831 15.7399C49.1125 14.4312 40.7432 16.0865 33.6858 20.407C26.6286 24.7275 21.3483 31.4285 18.7981 39.3005C18.3301 40.7454 16.7794 41.5372 15.3345 41.0691C13.8896 40.6011 13.0978 39.0504 13.5658 37.6055C16.5203 28.4853 22.638 20.7217 30.8141 15.7162Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66699 50C7.66699 48.4812 8.89821 47.25 10.417 47.25H64.5837C66.1025 47.25 67.3337 48.4812 67.3337 50C67.3337 51.5188 66.1025 52.75 64.5837 52.75H10.417C8.89821 52.75 7.66699 51.5188 7.66699 50Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9848 34.5873C49.0183 33.4743 50.7583 33.4099 51.8712 34.4433L66.4545 47.985C67.0149 48.5054 67.3337 49.2353 67.3337 50C67.3337 50.7647 67.0149 51.495 66.4545 52.0154L51.8712 65.557C50.7583 66.5904 49.0183 66.526 47.9848 65.413C46.9514 64.3001 47.0158 62.5601 48.1288 61.5266L60.5419 50.0002L48.1287 38.4737C47.0158 37.4402 46.9514 35.7002 47.9848 34.5873Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.143f9ed6407acbd9ba034cf99fa2c902.svg";
export { ForwardRef as ReactComponent };